import { GenericTable } from "@shared/components/GenericTable";
import { PageHeader } from "@shared/components/PageHeader";
import { TableColumn } from "@shared/types/table";

export const HistoricalPerformance = ({data}: {data: any}) => {
  const columns: TableColumn<any>[] = [
    {
      key: "label",
      header: "Time Period",
      sortable: true,
    },
    {
      key: ``,
      header: "Reading Period",
      sortable: true,
      headerTooltip: "Start and end dates for each period.",
      render: (value,row) => {
        return (
          <div className="flex items-center gap-2">
            <span>{row.startDate || "N/A"} - {row.endDate || "N/A"}</span>
          </div>
        );
      },
    },
    {
      key: "completionRate",
      header: "Completion Rate",
      sortable: true,
      headerTooltip: "Percentage of meters successfully read.",
    },
    {
      key: "onTimeCompletion",
      header: "On‑Time Completion",
      sortable: true,
      headerTooltip: "Percentage of meters read within scheduled time.",
    },
    {
      key: "readingAccuracy",
      header: "Reading Accuracy",
      sortable: true,
      headerTooltip: "Percentage of valid readings.",
    },
  ];
  return (
    <div>
      <PageHeader
        title="Historical Performance"
        subtitle="Compare this read cycle's performance with previous cycles and historical averages."
      />
      <div className="space-y-4 mt-6">
        <GenericTable
          data={data?.historicalPerformance || []}
          columns={columns}
          rowKey="id"
          selectable={false}
          emptyMessage="No data available"
        />
      </div>
    </div>
  );
};
